#import '../queries/HaftarahDetails.graphql'
mutation SetHaftarahToBarMitzvah($haftarah: ID!, $barMitzvah: String!) {
  setHaftarahToBarMitzvah(haftarah: $haftarah, barMitzvah: $barMitzvah) {
    ok
    errors
    haftarah {
      ...haftarahDetails
    }
  }
}
